import moment from "moment";

export class ActionHistory {
    actionHistoryId: number
    date: Date
    actionUser: string
    documentId: number
    actionId: number
    actionName: string

    constructor(object: any) {
        this.actionHistoryId = object.actionHistoryId;
        this.date = moment(object.date).toDate();
        this.actionUser = object.actionUser;
        this.documentId = object.documentId;
        this.actionId = object.action ? object.action.actionId : 0;
        this.actionName = object.action ? object.action.actionName : "";
    }
}
